export default "__VITE_ASSET__D92Kmabv__"